/**
 * @file: WiredScrollToBottomPill.tsx
 *
 * State wrapper for the pure {@link ScrollToBottomPill}. Reads the scroll
 * coordinator's view subjects — `showPill$` (the controller owns the grace
 * window), the unread counter, and the measured input-bar height so the pill
 * keeps its constant gap above the composer.
 */

import { useChatConversation } from '@euler/app/flows/chat/lib/conversation/context';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { useBehaviorSubject } from '@euler/utils/hooks';
import { AnimatePresence } from 'moti';
import { FC, memo } from 'react';
import { ScrollToBottomPill } from './ScrollToBottomPill';

export const WiredScrollToBottomPill: FC = memo(() => {
  const { rpx } = useResponsiveContext();
  const { scroll } = useChatConversation().coordinator;
  const [showPill] = useBehaviorSubject(scroll.showPill$);
  const [newMessageCount] = useBehaviorSubject(scroll.newMessageCount$);
  const [inputBarHeight] = useBehaviorSubject(scroll.inputBarHeight$);

  return (
    <AnimatePresence>
      {showPill ? (
        <ScrollToBottomPill
          key="pill"
          bottomOffset={inputBarHeight + rpx(16)}
          newMessageCount={newMessageCount}
          onPress={scroll.scrollToBottom}
        />
      ) : null}
    </AnimatePresence>
  );
});
